module.exports = __webpack_public_path__ + "img/bg_3.0f59bf57.jpg";